import React from 'react';

/**
 * 卡片组件，用于显示内容区块
 * @param {node} children - 卡片内容
 * @param {string} title - 卡片标题
 * @param {node} icon - 卡片标题旁的图标
 * @param {node} actions - 卡片右上角的操作区
 * @param {string} className - 额外的CSS类名
 * @param {object} props - 其他属性
 */
const Card = ({ 
  children, 
  title, 
  icon, 
  actions, 
  className = '', 
  ...props 
}) => {
  return (
    <div className={`card shadow-sm ${className}`} {...props}>
      {(title || actions) && (
        <div className="card-header d-flex justify-content-between align-items-center">
          {title && (
            <h5 className="card-title mb-0 d-flex align-items-center">
              {icon && <span className="card-icon me-2">{icon}</span>}
              {title}
            </h5>
          )}
          
          {actions && <div className="card-actions">{actions}</div>}
        </div>
      )}
      
      <div className="card-body">
        {children}
      </div>
    </div>
  );
};

/**
 * 卡片网格组件，用于以网格形式展示多个卡片
 * @param {node} children - 子卡片组件
 * @param {number} columns - 每行显示的卡片数量
 * @param {string} className - 额外的CSS类名
 */
export const CardGrid = ({ 
  children, 
  columns = 3, 
  className = '' 
}) => {
  // 根据列数计算每个卡片的Bootstrap列宽
  const getColumnClass = () => {
    switch (columns) {
      case 1:
        return 'col-12';
      case 2:
        return 'col-md-6';
      case 4:
        return 'col-md-6 col-lg-3';
      case 5:
        return 'col-md-4 col-lg-2 col-xl-3';
      case 6:
        return 'col-md-4 col-lg-2';
      case 3:
      default:
        return 'col-md-4';
    }
  };

  // 如果children是数组，则为每个子元素添加列类名
  const renderChildren = () => {
    if (!Array.isArray(children)) {
      return <div className={getColumnClass()}>{children}</div>;
    }

    return React.Children.map(children, (child, index) => {
      if (!child) return null;
      
      return (
        <div key={index} className={`${getColumnClass()} mb-4`}>
          {child}
        </div>
      );
    });
  };

  return (
    <div className={`row g-4 ${className}`}>
      {renderChildren()}
    </div>
  );
};

export default Card; 